import React, { createElement } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
(function injectResourceHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  const hints: {
    rel: string;
    href: string;
    as?: string;
    crossOrigin?: string;
    fetchPriority?: string;
  }[] = [{
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossOrigin: 'anonymous'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous'
  }, {
    rel: 'preload',
    as: 'image',
    href: 'https://cdn.magicpatterns.com/uploads/nQhZwBsjXHJbTcFVYRiM2Q/Mockup_-_Sistema_Digestion_Superior_(1x1)-convertido-de-png.webp',
    fetchPriority: 'high'
  }];
  hints.forEach(h => {
    if (document.querySelector(`link[rel="${h.rel}"][href="${h.href}"]`)) return;
    const link = document.createElement('link');
    link.rel = h.rel;
    link.href = h.href;
    if (h.as) link.as = h.as;
    if (h.crossOrigin) link.crossOrigin = h.crossOrigin;
    if (h.fetchPriority) (link as any).fetchPriority = h.fetchPriority;
    head.appendChild(link);
  });
})();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-255" />);
}